import React from 'react';
import classNames from 'classnames';
import closeImg from '../../../assets/images/close.svg';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import StringInput from '../inputs/string-input';
import { useContactsStore, useStore } from '../../../store';
import { ContactType, IContact } from '../../../domains/common.domain';

export interface IContactFormProps {
  index: number;
  contact: IContact;
  handleChange: (field: keyof IContact, value: string) => void;
  removeContact?: () => void;
  contactsType: ContactType;
}

export const ContactForm = observer((props: IContactFormProps) => {
  const { t } = useTranslation('', { keyPrefix: 'CONTACT' });
  const { t: tError } = useTranslation('', { keyPrefix: 'CONTACT.ERRORS' });
  const { index, contact, handleChange, removeContact, contactsType } = props;
  const { tenantStore } = useStore();
  const { maxPhoneNumberLength, minPhoneNumberLength } = tenantStore.config;
  const { contactsStore } = useContactsStore(contactsType);
  const { hideEmail, hidePhone } = contactsStore;

  return (
    <div className={classNames('container-contact', index > 0 && 'additional-contact')}>
      {index > 0 && (
        <button className={'contact-close-btn'} onClick={e => (removeContact ? removeContact() : undefined)}>
          <img src={closeImg} alt="" />
        </button>
      )}
      <div className={'container-two-columns'}>
        <StringInput
          value={contact.firstName}
          label={t('FIRST_NAME')}
          name={'firstName'}
          onUpdate={value => handleChange('firstName', value)}
          error={contact.firstName.errorType ? tError(`${contact.firstName.errorType.toUpperCase()}_FIRST_NAME`) : ''}
        />
        <StringInput
          value={contact.lastName}
          label={t('LAST_NAME')}
          name={'lastName'}
          onUpdate={value => handleChange('lastName', value)}
          error={contact.lastName.errorType ? tError(`${contact.lastName.errorType.toUpperCase()}_LAST_NAME`) : ''}
        />
      </div>

      {!hideEmail && (
        <StringInput
          value={contact.email}
          label={t('EMAIL')}
          name={'email'}
          onUpdate={value => handleChange('email', value)}
          error={contact.email.errorType ? tError(`${contact.email.errorType.toUpperCase()}_EMAIL`) : ''}
        />
      )}

      {!hidePhone && contact.phoneNumber && (
        <StringInput
          value={contact.phoneNumber}
          label={t('PHONE_NUMBER')}
          name={'phoneNumber'}
          onUpdate={value => handleChange('phoneNumber', value)}
          maxLength={maxPhoneNumberLength}
          error={
            contact.phoneNumber.errorType
              ? tError(`${contact.phoneNumber.errorType.toUpperCase()}_PHONE_NUMBER`, { data: minPhoneNumberLength })
              : ''
          }
        />
      )}
    </div>
  );
});
